<template>
    <v-container fluid id="alerts-banner">
        <template v-for="(message, index) in messages">
            <v-alert
                :value="message.show"
                :color="message.type"
                :icon="message.icon"
                transition="slide-x-reverse-transition"
                v-bind:key="index"
            >
                {{message.handleShowEvent()}}
                <strong>{{message.text}}</strong>
            </v-alert>
        </template>
    </v-container>
</template>

<style>
#alerts-banner {
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
  z-index: 7;
}
</style>

<script>
    export default {
        name: 'flash-message',
        data() {
            return {
                messages: []
            };
        },
        created() {
            this.$eventService.$on('flashMessage', this.addMessage);
        },
        methods: {
            getIcon(type) {
                switch(type) {
                    case 'success':
                        return 'check_circle'
                        break;
                    case 'info':
                        return 'info'
                        break;
                    case 'warning':
                        return 'priority_high'
                        break;
                    case 'error':
                        return 'warning'
                        break;
                }
            },
            addMessage(message){
                {
                    this.messages.push({
                        text: message.text,
                        type: (typeof message.type == 'undefined') ? 'info' : message.type,
                        icon: this.getIcon((typeof message.type == 'undefined') ? 'info' : message.type),
                        show: (typeof message.show == 'undefined') ? true : message.show,
                        timeout: (typeof message.timeout == 'undefined') ? 3000 : message.timeout,
                        important: (typeof message.important == 'undefined') ? false : message.important,
                        remove(){
                            this.show = false;
                        },
                        handleShowEvent(){
                            {
                                if (!this.important) {
                                    setTimeout(
                                            () => this.remove(),
                                            this.timeout
                                    )
                                }
                            }
                        }
                    });
                }
            },
        },
        computed: {
            messagesToShow() {
                return this.messages.filter(it => it.show);
            }
        },
        events: {
            flashMessage(message) {
                this.addMessage(message)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FlashMessage.vue